'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _googleMapReact = require('google-map-react');

var _googleMapReact2 = _interopRequireDefault(_googleMapReact);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DynamicMap = function (_Component) {
  (0, _inherits3.default)(DynamicMap, _Component);

  function DynamicMap() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DynamicMap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DynamicMap.__proto__ || (0, _getPrototypeOf2.default)(DynamicMap)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clusterFactor: 10000
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DynamicMap, [{
    key: 'handleOnCenterChange',
    value: function handleOnCenterChange(_ref2) {
      var center = _ref2.center,
          zoom = _ref2.zoom,
          bounds = _ref2.bounds,
          marginBounds = _ref2.marginBounds;

      var newFactor = 10000;

      // TODO Find an algorithm
      if (zoom < 6) {
        newFactor = 0.1;
      } else if (zoom < 12) {
        newFactor = 100;
      } else if (zoom < 14) {
        newFactor = 250;
      } else if (zoom < 16) {
        newFactor = 1000;
      }

      this.setState({
        clusterFactor: newFactor
      });

      this.props.onCenterChange({
        center: center,
        zoom: zoom,
        bounds: bounds,
        marginBounds: marginBounds
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var newCenter = {
        lat: this.props.geoLatitude || this.props.centerLat,
        lng: this.props.geoLongitude || this.props.centerLng
      };

      var _props = this.props,
          apiKey = _props.apiKey,
          drawDirection = _props.drawDirection,
          events = _props.events,
          handleOnClick = _props.handleOnClick,
          initialZoom = _props.initialZoom,
          mapOptions = _props.mapOptions;

      var Marker = this.props.marker;

      var clusterFactor = this.state.clusterFactor;


      var clusteredEvents = events.reduce(function (acc, ev) {
        var clusteredLat = Math.round(ev.lat * clusterFactor) / clusterFactor;
        var clusteredLng = Math.round(ev.lng * clusterFactor) / clusterFactor;
        var key = clusteredLat + '|' + clusteredLng;

        if (!acc[key]) {
          acc[key] = []; // eslint-disable-line no-param-reassign
        }
        acc[key].push(ev);

        return acc;
      }, {});
      var eventsClusters = (0, _keys2.default)(clusteredEvents).map(function (key) {
        if (clusteredEvents[key].length > 1) {
          var meanLat = clusteredEvents[key].reduce(function (acc, ev) {
            return acc + ev.lat;
          }, 0) / clusteredEvents[key].length;
          var meanLng = clusteredEvents[key].reduce(function (acc, ev) {
            return acc + ev.lng;
          }, 0) / clusteredEvents[key].length;

          return {
            id: clusteredEvents[key].reduce(function (acc, ev) {
              if (acc === '') {
                return '' + ev.id;
              }

              return acc + '-' + ev.id;
            }, ''),
            lat: meanLat,
            lng: meanLng,
            events: clusteredEvents[key]
          };
        }

        return clusteredEvents[key][0];
      });

      var orderedEvents = eventsClusters.sort(function (a, b) {
        var latDiff = b.lat - a.lat;
        var lngDiff = b.lng - a.lng;

        var lat = latDiff > 0 ? 1 : -1;
        var lng = lngDiff > 0 ? 1 : -1;

        return (drawDirection[0] === 'N' ? -lat : lat) || (drawDirection[1] === 'E' ? -lng : lng);
      });

      return _react2.default.createElement(
        'div',
        { className: 'DynamicMap' },
        _react2.default.createElement(
          _googleMapReact2.default,
          {
            bootstrapURLKeys: {
              key: apiKey,
              v: '3.30'
            },
            center: newCenter,
            defaultZoom: initialZoom,
            onChange: this.handleOnCenterChange.bind(this),
            options: mapOptions,
            style: { minHeight: '1px' } // The map does not always display without this
          },
          orderedEvents.map(function (e) {
            return _react2.default.createElement(Marker, (0, _extends3.default)({ key: e.id + '-' + e.start_date, onClick: handleOnClick.bind(_this2, e.id) }, e));
          })
        )
      );
    }
  }]);
  return DynamicMap;
}(_react.Component);

DynamicMap.propTypes = {
  /**
   * The Google Maps API key
   */
  apiKey: _propTypes2.default.string.isRequired,
  /**
   * The starting latitude.
   */
  centerLat: _propTypes2.default.number.isRequired,
  /**
   * The starting longitude.
   */
  centerLng: _propTypes2.default.number.isRequired,
  /**
   * Order in which events are drawn. Used to manage z-indices.
   */
  drawDirection: _propTypes2.default.oneOf(['NW', 'NE', 'SW', 'SE']),
  /**
   * A list of events to render.
   */
  events: _propTypes2.default.array.isRequired,
  /**
   * A dynamic, overriding latitude as provided by the Geolocation API, for example
   */
  geoLatitude: _propTypes2.default.number,
  /**
   * A dynamic, overriding longitude as provided by the Geolocation API, for example
   */
  geoLongitude: _propTypes2.default.number,
  /**
   * Method called when clicking on a marker.
   */
  handleOnClick: _propTypes2.default.func,
  /**
   * The starting zoom.
   */
  initialZoom: _propTypes2.default.number.isRequired,
  /**
   * Configuration object passed to the underlying maps API.
   */
  mapOptions: _propTypes2.default.object,
  /**
   * A component or node to display as a marker.
   */
  marker: _propTypes2.default.func,
  /**
   * Method called when the map has moved.
   * It is recommended to fetch as far as the largest dimension
   * from the borders to ensure there are no gaps when dragging.
   */
  onCenterChange: _propTypes2.default.func
};

DynamicMap.DefaultMarker = function () {
  return _react2.default.createElement(_.MapMarker, null);
};

DynamicMap.defaultProps = {
  drawDirection: 'NW',
  mapOptions: {
    clickableIcons: false
  },
  marker: DynamicMap.DefaultMarker
};
exports.default = DynamicMap;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/DynamicMap.js
// module id = 264
// module chunks = 0